import React, { useState, useEffect } from 'react';
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import HeroVideo from '../components/HeroVideo'
import image1 from '../assets/landing-page-diancempaka.jpg'
import LoadingSpinner from '../components/LoadingSpinner'



const Home = () => {
    const [isLoading, setIsLoading] = useState(true);

    // Simulating an API or data fetching process
    useEffect(() => {
        const loadData = async () => {
            // Simulate network delay
            await new Promise(resolve => setTimeout(resolve, 2000));
            setIsLoading(false);
        };
        loadData();
    }, []);

    return (
        <>
            <Nav />
            <div className="min-h-screen flex justify-center items-center bg-gray-100">
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        <HeroVideo />
                        <div className="container py-8 px-10 overflow-hidden">
                            <div className="image-container">
                                <img src={image1} alt="DC-landing-page"></img>
                            </div>
                                <p><b>PT Dian Cempaka</b> telah beroperasi di Jakarta sejak 1984 (beroperasi dengan nama PT. Prima Bintang Indorejeki sampai 1994). Selama dua dekade terakhir kami telah mengumpulkan kepercayaan pasar yang kuat dan sehat melalui prinsip sederhana yang kami ikuti:<b> Dapatkan Kepercayaan dengan kualitas produk yang terpercaya.</b></p>
                                <br></br>
                                <p>Sebagai <b>distributor pipa kembla</b>, Kami telah membangun reputasi yang kuat untuk menyediakan produk di banyak proyek mulai dari apartemen, rumah sakit, hotel, dan banyak proyek lainnya dengan kualitas dan harga yang kompetitif.</p>
                                <br></br>
                                <p>Mengetahui banyak vendor memberi Anda banyak pilihan, tetapi menyia-nyiakan lebih banyak waktu dalam membuat perbandingan. PT. Dian Cempaka akan menjadi pilihan terbaik untuk perusahaan Anda, karena karena kami adalah <b>distributor tunggal pipa Kembla di Indonesia</b>, kami selalu menjamin ketersediaan stock dan kualitas, dengan harga yang kompetitif.</p> 
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    )
}

export default Home